const SCROLL_DIRECTION = {
    VERTICAL: 'VERTICAL',
    HORIZONTAL: 'HORIZONTAL',
};
export default SCROLL_DIRECTION;
//# sourceMappingURL=layoutParams_structure_scrollDirection.js.map